import { FC } from "react";

import { Box, Button, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

interface Props {
  busy: boolean;
  onResume: () => void;
}

// Shown in place of the live room when the interviewer's own pause
// disconnects them. Resume reconnects immediately — no waiting room.
const OfficerBreakRoom: FC<Props> = ({ busy, onResume }) => {
  const { t } = useTranslation("connect");
  return (
    <Box sx={{ m: "auto", textAlign: "center", maxWidth: 420, p: 3 }}>
      <Typography variant="h6" gutterBottom>
        {t("breakRoom.title")}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        {t("breakRoom.body")}
      </Typography>
      <Stack alignItems="center">
        <Button
          variant="contained"
          size="large"
          disabled={busy}
          onClick={onResume}
        >
          {busy ? t("breakRoom.resuming") : t("breakRoom.resume")}
        </Button>
      </Stack>
    </Box>
  );
};

export default OfficerBreakRoom;
